import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import viewMixin from '../../../components/core/consumers/viewMixin';
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
var emptyModel = {
  transformer: {
    definition: '$.value',
    type: 'jsonata',
    contentTypes: {}
  },
  properties: {}
};
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewConnectorsConsumersTransformers',
  mixins: [viewMixin, userItemsPerListMixin],
  data: function data() {
    return {
      searchItem: '',
      selectedAccounts: [],
      accounts: [],
      selectedAccount: null,
      loadingAccounts: true,
      transformerTypes: ['jsonata', 'javascript'],
      transformerModel: cloneDeep(emptyModel),
      deletePrompt: false,
      deleteItemId: null,
      tableOptions: defaultTableOptions
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('authentication', ['tenantId'])), {}, {
    hasNoTransformers: function hasNoTransformers() {
      return this.transformers.length === 0;
    },
    inputTypes: function inputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    outputTypes: function outputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    showCodeMirror: function showCodeMirror() {
      // return this.transformerModel.transformer.type === 'jsonata';
      return true;
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Filter.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.type'),
          sortable: true,
          value: 'transformer.type',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.outputType'),
          sortable: true,
          value: 'transformer.contentTypes.output'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions',
          align: 'end'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.fetchTransformers(this.selectedAccounts);
    },
    inputTypes: function inputTypes() {
      if (this.inputTypes.length === 1 || this.inputTypes.indexOf(this.transformerModel.transformer.contentTypes.input) < 0) {
        this.transformerModel.transformer.contentTypes.input = this.inputTypes[0];
      }
    },
    outputTypes: function outputTypes() {
      if (this.outputTypes.length === 1 || this.outputTypes.indexOf(this.transformerModel.transformer.contentTypes.output) < 0) {
        this.transformerModel.transformer.contentTypes.output = this.outputTypes[0];
      }
    },
    'transformerModel.transformer.type': function transformerModelTransformerType() {
      switch (this.transformerModel.transformer.type) {
        case 'jsonata':
          this.transformerModel.transformer.definition = '$.value';
          break;

        case 'javascript':
          this.transformerModel.transformer.definition = 'return x.value';
          break;
      }
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  methods: {
    openEdit: function openEdit() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!item) {
        this.selectedAccount = null;
        this.$router.push('/connectors/consumers/transformers/create');
      } else {
        this.selectedAccount = this.accounts.find(function (acc) {
          return acc.id === item.tenantId;
        });
        this.$router.push("/connectors/consumers/transformers/".concat(item.id));
      }
    },
    save: function save() {
      var _this = this;

      var promise = null;

      if (this.transformerModel.id) {
        promise = ApiService.consumerTransformersUpdate(this.transformerModel.id, this.transformerModel);
      } else {
        promise = ApiService.consumerTransformersCreate(this.selectedAccount, this.transformerModel);
      }

      promise.then(function () {
        _this.fetchTransformers();

        _this.closeDialog();
      }).catch(function (e) {
        _this.$snack(e.response.data.message, 'error');
      });
    },
    showDeletePrompt: function showDeletePrompt(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    deleteTransformer: function deleteTransformer(id) {
      var _this2 = this;

      ApiService.consumerTransformersDelete(id).then(function () {
        _this2.fetchTransformers(_this2.selectedAccounts);
      }).catch(function (error) {
        _this2.$snack(error.response.data.message, 'error');
      }).finally(function () {
        _this2.deletePrompt = false;
      });
    },
    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this3.accounts = accounts;
      }).catch(function (error) {
        console.error(error);

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};